module.exports = __webpack_public_path__ + "e651f4e25f9571bb0a67323fede55760.woff2";